<template>
  <modal
    :show.sync="show"
    modalClasses="medium-sized-modal"
    :hide-footer="true"
  >
    <h3 slot="header" class="mb-0 font-weight-500">Assign To</h3>

    <b-form>
      <b-row>
        <b-col cols="12" v-if="show_tm">
										<b-form-group label="TM:">
            <el-select v-model="selected_se_id" placeholder="Select" filterable :disabled="IsIMoney()">
              <el-option selected value=""></el-option>
              <el-option
                v-for="item in userSeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" v-if="show_ssa">
          <b-form-group label="Advisor:">
            <el-select
              v-model="selected_ssa_id"
              placeholder="Select"
              filterable
            >
              <el-option selected value=""></el-option>
              <el-option
                v-for="item in agentsList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" v-if="show_sse">
          <b-form-group label="Support">
            <el-select
              v-model="selected_sse_id"
              placeholder="Select"
              filterable
            >
              <el-option selected value=""></el-option>
              <el-option
                v-for="item in userSseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </b-form-group>
        </b-col>
        <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
          <b-button
            type="submit"
            class="w-100"
            variant="primary"
            @click.prevent="assignAgent"
            >Confirm</b-button
          >
        </b-col>
      </b-row>
    </b-form>
  </modal>
</template>
<script>
import Modal from "@/components/Modal";
import { Select, Option } from "element-ui";
import {
  notifyFunctionMixin,
  helperFunctionMixin,
  axios,
  services,
  getHeader,
} from "@/assets/js/httpImports.js";
import mainEventBus from "@/assets/js/mainEventBus";
import { mapState, mapActions } from "pinia";
import { useAuthStore } from "@/stores/authStore";
import { useAccessControlStore } from "@/stores/accessControlStore";
import { useMessagingStore } from "@/stores/messagingStore";
import { CAN_ASSIGN_ROLE_IDS } from "@/assets/js/roles.js";

export default {
  props: {
    show_assign_customers_to: Boolean,
    agents_list: Array,
    customer_details: {
            type: [Object, Array]
        },
    multiple_selection: Array,
    show_ssa: Boolean,
    show_sse: Boolean,
    show_tm: Boolean,
  },
  mixins: [notifyFunctionMixin, helperFunctionMixin],
  components: {
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  computed: {
    show: {
      get() {
        return this.show_assign_customers_to;
      },
      set(newVal) {
        this.$emit("update:show_assign_customers_to", newVal);
      },
    },
    ...mapState(useAuthStore, ["auth_user"]),
    ...mapState(useAccessControlStore, [
      "userSsaList",
      "userSseList",
      "userSeList",
      "userHeadList",
      "userProcessorList",
      "userHubManagerList",
    ]),
    // userSsaUnderHubManager(){
    // 	if(this.isEmpty(this.selected_hub_manager_id)) return this.userSsaList;

    // 	let selected_hub_manager_id = this.selected_hub_manager_id;
    // 	let selected_ssa_id = this.selected_ssa_id;
    // 	let result = _.filter(this.userSsaList,(o)=>{
    // 		return (((o.parent_hub_manager_ids).indexOf(selected_hub_manager_id) != -1) || (o.id == selected_ssa_id));
    // 	});
    // 	return result;
    // }
    // salesAdvisors() {
    //     return this.agents_list
    //     // return this.agents_list.filter((agent) =>
    //     //     agent.roles.some(
    //     //     (role) =>
    //     //         role.role_name === "Sales Advisor Manager" ||
    //     //         role.role_name === "Mobile Sales Advisory" ||
    //     //         role.role_name === "Sales Support Manager" ||
    //     //         role.role_name === "Sales Manager" ||
    //     //         role.role_name === "SSA"
    //     //     )
    //     // );
    // },

    // salesSupportExecutives() {
    //     return this.agents_list.filter((agent) =>
    //         agent.roles.some(
    //         (role) =>
    //             role.role_name === "SSE"
    //         )
    //     );
    // },

    // hubManagers() {
    //     return this.agents_list.filter((agent) =>
    //         agent.roles.some(
    //         (role) =>
    //             role.role_name.toLowerCase().includes("hub manager")
    //         )
    //     );
    // },
  },
  watch: {
    customer_details(newVal) {
      if (newVal) {
        this.selected_se_id = newVal.se ? newVal.se.id : '';
        this.selected_ssa_id = newVal.ssa ? newVal.ssa.id : "";
        this.selected_sse_id = newVal.sse ? newVal.sse.id : "";
      }
    },

    multiple_selection(newVal) {
      if (newVal) {
        this.selected_ids = newVal.map((customer) => customer.customer_id);
      }
    },

    corporate(newVal) {
        if (newVal === 'iMoney') {
            this.selected_se_id = null
        }
    }
  },
  data() {
    return {
      selected_ids: [],
      selected_ssa_id: "",
      selected_sse_id: "",
      selected_se_id: '',
      CAN_ASSIGN_ROLE_IDS: CAN_ASSIGN_ROLE_IDS,
    };
  },
  async created() {
    this.agentsList = await this.getUserList()
  },
  methods: {
    ...mapActions(useMessagingStore, ["getProfileBundleKey", "checkUserGroup"]),
    IsIMoney() {
        if("corporate" in this.customer_details) {
            if (this.customer_details.corporate.includes("iMoney")) {
              this.selected_se_id = null;
              return true
            } else return false
        } else {
            for(var i = 0 ; i < this.customer_details.length; i ++) {
                if(this.customer_details[i].corporate.includes("iMoney")) {
                  this.selected_se_id = null;
                  return true
                };
            }
            return false;
        }
    },
    assignAgent() {
      if (this.multiple_selection.length > 0) {
        let form = {
          ids: this.selected_ids,
        };

        if (this.selected_ssa_id !== "" && this.selected_ssa_id !== null) {
          form.ssa_id = this.selected_ssa_id;
        }

        if (this.selected_sse_id !== "" && this.selected_sse_id !== null) {
          form.sse_id = this.selected_sse_id;
        }

        if (this.selected_se_id !== '' && this.selected_se_id !== null) {
					form.se_id = this.selected_se_id;
        }

        axios
          .post(services.customer + "customers/assign_agent_bulk", form, {
            headers: getHeader(),
          })
          .then((res) => {
            this.autoSetChatGroup();
            this.notifySuccess("<b>Customers Agents - Successfully Updated.");
            mainEventBus.$emit("refresh-table-data");
          })
          .catch((e) => {
            this.errorFunction(e);
          });
      } else {
        let params = {};
        if (this.selected_ssa_id !== "" && this.selected_ssa_id !== null) {
          params["ssa_id"] = this.selected_ssa_id;
        }

        if (this.selected_sse_id !== "" && this.selected_sse_id !== null) {
          params["sse_id"] = this.selected_sse_id;
        }

        if (
          this.selected_se_id !== "" &&
          this.selected_se_id !== null
        ) {
          params["se_id"] = this.selected_se_id;
        }
        axios
          .put(
            services.customer +
              "customers/" +
              this.customer_details.customer_id +
              "/assign_agent",
            params,
            { headers: getHeader() }
          )
          .then((res) => {
            this.autoSetChatGroup();
            this.notifySuccess(
              "<b>Customer Agents: " +
                res.data.data.name +
                "</b> - Successfully Updated."
            );
            mainEventBus.$emit("refresh-table-data");
          })
          .catch((e) => {
            this.errorFunction(e);
          });
      }
    },
    autoSetChatGroup() {
      let user_id = null;
      let type = "customer";
      let channelIds = _gAuth.activeCorpSettings(
        "lead_reassign_only_channel_ids",
        []
      );
      const customers =
        this.multiple_selection.length > 0
          ? this.multiple_selection
          : [this.customer_details];

      if (!_gHlp.isEmpty(customers)) {
        if (this.selected_ssa_id !== "" && this.selected_ssa_id !== null) {
          user_id = this.selected_ssa_id;
          customers.forEach((item) => {
            let bundle_key = this.getProfileBundleKey("customer", item);
            let is_add_all_group = true;
            this.checkUserGroup(user_id, bundle_key, type, is_add_all_group);
          });
        }

        if (this.selected_sse_id !== "" && this.selected_sse_id !== null) {
          user_id = this.selected_sse_id;
          customers.forEach((item) => {
            let bundle_key = this.getProfileBundleKey("customer", item);
            let is_add_all_group = true;
            this.checkUserGroup(user_id, bundle_key, type, is_add_all_group);
          });
        }
      }
    },
  },
};
</script>
